export const containerId = 'payment-form';
export const scriptId = 'iframe-loader';

export default {
  containerId,
};
